import React from "react";
import { BACKEND_URL } from "@/lib/backend";

// Top-level error boundary: renders a graceful fallback instead of a white
// screen when any descendant throws during render/lifecycle, and reports the
// crash to the backend for diagnostics.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      fetch(`${BACKEND_URL}/api/client-errors`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: String(error && (error.message || error)),
          stack: error && error.stack ? String(error.stack) : null,
          componentStack: info && info.componentStack ? String(info.componentStack) : null,
          url: typeof window !== "undefined" ? window.location.href : null,
          userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) {
      /* never let reporting throw */
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            background: "var(--brand-primary)",
            color: "#fff",
            fontFamily: "system-ui, sans-serif",
            padding: 24,
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 480 }}>
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                background: "var(--brand-button)",
                color: "var(--brand-primary)",
                display: "grid",
                placeItems: "center",
                fontWeight: 900,
                fontSize: 24,
                margin: "0 auto 18px",
              }}
            >
              !
            </div>
            <h1 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 10px" }}>
              Something went wrong
            </h1>
            <p style={{ color: "#c7d2e2", fontSize: 14, margin: "0 0 20px", lineHeight: 1.6 }}>
              We hit an unexpected error while loading this page. Please try
              reloading. If the problem persists, it has been reported to our team.
            </p>
            <button
              data-testid="app-error-reload"
              onClick={() => window.location.reload()}
              style={{
                cursor: "pointer",
                border: 0,
                background: "var(--brand-button)",
                color: "var(--brand-primary)",
                borderRadius: 999,
                padding: "10px 22px",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
